// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"239":"e3b4f3bd62cb6495","290":"ee3b49379a75a406"}[chunkId] + ".css";
};